import { cn } from 'noddi-ui-common';

interface ProgressBarProps {
  value: number;
  className?: string;
  wrapperClassName?: string;
  showPercentage?: boolean;
}

export const NoddiProgressBar = ({ value, className, wrapperClassName, showPercentage = false }: ProgressBarProps) => {
  const normalizedValue = Math.max(0, Math.min(100, value));

  return (
    <div className={cn('relative w-full min-w-24 overflow-hidden rounded-full border', wrapperClassName)}>
      <div className={cn('h-3.5 bg-primary transition-all', className)} style={{ width: `${normalizedValue}%` }} />
      {showPercentage && (
        <span className='absolute top-1/2 left-2 -translate-y-1/2 text-xs font-medium text-white'>
          {normalizedValue}%
        </span>
      )}
    </div>
  );
};
